import { C } from "../../constants/theme";

// Grade de miniaturas com checkbox — compartilhada pelos dois modais do
// MakerWorld (fotos do produto e importação na Calculadora).
// `jaAdicionadas`: ids que já estão no produto — ganham o selo "Já na galeria".
export function GradeFotosMakerWorld({ imagens, marcadas, onAlternar, desabilitado, jaAdicionadas }) {
  return (
    <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))", gap:10 }}>
      {imagens.map((img, i) => {
        const marcada = marcadas.has(img.id);
        return (
          <label key={img.id} title={img.origem === "capa" ? "Capa do modelo" : undefined}
            style={{ position:"relative", display:"block", cursor:desabilitado ? "default" : "pointer", borderRadius:10, overflow:"hidden", aspectRatio:"1 / 1",
              border:"2px solid " + (marcada ? C.accent2 : C.border), opacity:marcada ? 1 : 0.55, transition:"opacity .12s, border-color .12s" }}>
            <img src={img.thumb} alt={`Foto ${i + 1} do modelo`} loading="lazy" referrerPolicy="no-referrer"
              style={{ width:"100%", height:"100%", objectFit:"cover", display:"block", background:C.panel }} />
            <input type="checkbox" checked={marcada} disabled={desabilitado} onChange={() => onAlternar(img.id)} aria-label={`Selecionar foto ${i + 1}`}
              style={{ position:"absolute", top:8, left:8, width:18, height:18, accentColor:C.accent2, cursor:"inherit" }} />
            {jaAdicionadas?.has(img.id) && (
              <span style={{ position:"absolute", top:6, right:6, fontSize:10, fontWeight:700, background:"#000a", color:"#fff", padding:"2px 7px", borderRadius:6 }}>Já na galeria</span>
            )}
            {img.origem === "capa" && (
              <span style={{ position:"absolute", bottom:6, left:6, fontSize:10, fontWeight:700, background:"#000a", color:"#fff", padding:"2px 7px", borderRadius:6 }}>Capa</span>
            )}
          </label>
        );
      })}
    </div>
  );
}
